import React, { useState, useEffect } from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { IoIosCloseCircleOutline } from 'react-icons/io';

import TabPanel from '../../../components/TabPanel';
import Detalhes from './tabs/Detalhes';
import Complementos from './tabs/Complementos';
import Disponibilidade from './tabs/Disponibilidade';

import {
  CloseButton,
  DrawerContainer,
  DrawerTitle,
} from '../../../drawer_styles';

import { useSimpleProduct } from '../../../../../../../hooks/newSimpleProduct';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';
import { MenuOptionButton } from '../../../../styles';
import api from '../../../../../../../services/api';
import { useAuth } from '../../../../../../../hooks/auth';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

interface ProdutoProps {
  id: number;
  unidade_medida_id: number;
  descricao: string;
  codigo: string;
  gtin: string;
  tipo: number;
  preco: number;
  observacao: string;
  imagem: string;
  estoque_minimo: number;
  estoque_atual: number;
  grupo_id: number;
}

interface QtdTurnos {
  index: number;
}

interface NewProdutoSimplesProps {
  grupo_produto_id: number;
  produto_id: number;
  tipo_produto: number;
  grupo_descricao: string;
  grupo_id: number;
  unidade_medida_id: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const CloneProdutoSimples: React.FC<NewProdutoSimplesProps> = ({
  grupo_id,
  grupo_descricao,
  tipo_produto,
  grupo_produto_id,
  produto_id,
  unidade_medida_id,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [complementoReleased, setComplementoReleased] = useState(true);
  const [value, setValue] = useState(0);

  const {
    product,
    filledData2,
    disponibilidadeReleased,
    disponibilidadeTabClicked,
    drawerValue,
    setDrawerValue,
    handleSetDisponibilidadeTabClicked,
    submit,
    createProduct,
    handleSetTurnos,
    createDisponibilidade,
    cleanData,
    handleSetSempreDisponivel,
    handleSetInitialQtdTurnos,
  } = useSimpleProduct();
  const { user } = useAuth();

  const {
    handleSetHasProductUpdated,
    hasProductUpdated,
    drawerWasClosed,
    handleSetDrawerWasClosed,
  } = useRegisterAdded();

  useEffect(() => {
    async function execute(): Promise<void> {
      let btnComplementoClicked = false;
      setComplementoReleased(true);

      if (disponibilidadeTabClicked && disponibilidadeReleased) {
        setComplementoReleased(false);
        btnComplementoClicked = true;
      }

      if (filledData2) {
        setIsOpen(false);
        // handleSetHasProductUpdated(true);
        window.location.reload();
        setDrawerValue(0);
      }

      if (hasProductUpdated) setIsOpen(false);

      if (drawerWasClosed) {
        setIsOpen(false);
        handleSetDrawerWasClosed(false);
      }
    }

    execute();
  }, [
    product,
    submit,
    filledData2,
    disponibilidadeReleased,
    disponibilidadeTabClicked,
    handleSetHasProductUpdated,
    hasProductUpdated,
    drawerWasClosed,
    setDrawerValue,
    handleSetDisponibilidadeTabClicked,
  ]);

  useEffect(() => {
    async function loadProdutoData(): Promise<void> {
      const productRequest = await api.post('/produto', { produto_id });
      const estoqueRequest = await api.post(`/estoque/estoque_produto`, {
        produto_id,
        empresa_id: user.empresa_id,
      });

      const productFormatted: ProdutoProps = {} as ProdutoProps;

      productFormatted.id = produto_id;
      productFormatted.unidade_medida_id =
        productRequest.data.unidade_medida_id;
      productFormatted.descricao = productRequest.data.descricao;
      productFormatted.codigo = productRequest.data.codigo;
      productFormatted.gtin = productRequest.data.gtin;
      productFormatted.tipo = productRequest.data.tipo;
      productFormatted.observacao = productRequest.data.observacao;
      productFormatted.imagem = productRequest.data.imagem;
      productFormatted.estoque_minimo = estoqueRequest.data.estoque_minimo;
      productFormatted.estoque_atual = estoqueRequest.data.estoque_atual;
      productFormatted.grupo_id = grupo_id;

      if (tipo_produto === 2) {
        productFormatted.preco = productRequest.data.preco_custo;
      } else {
        const precoRequest = await api.post(`/produto/preco/${produto_id}`);
        productFormatted.preco = precoRequest.data.valor;
      }

      createProduct({
        ...productFormatted,
        descricao: `${productFormatted.descricao} Clone`,
        gtin: '',
        codigo: '',
        empresa_id: user.empresa_id,
      });
    }

    async function loadDisponibilidade(): Promise<void> {
      const qtdTurnosFinded: QtdTurnos[] = [];
      const response = await api.get(`/produto/disponibilidade/${produto_id}`);

      const { role } = response.data;

      const hasFalseKeys = Object.values(role.dias).includes(false);
      if (role.turnos.length > 0) handleSetTurnos([...role.turnos]);

      for (let i = 0; i < role.turnos.length; i += 1) {
        qtdTurnosFinded.push({ index: i });
      }

      handleSetSempreDisponivel(!hasFalseKeys);
      handleSetInitialQtdTurnos([...qtdTurnosFinded]);
      createDisponibilidade(role);
    }

    if (isOpen) {
      loadProdutoData();

      if (tipo_produto != 2) {
        loadDisponibilidade();
      }
    }

    if (drawerWasClosed) {
      setValue(0);
      setIsOpen(false);
      handleSetDrawerWasClosed(false);
    }
  }, [
    drawerWasClosed,
    grupo_id,
    createDisponibilidade,
    createProduct,
    handleSetDrawerWasClosed,
    handleSetInitialQtdTurnos,
    handleSetSempreDisponivel,
    isOpen,
    handleSetTurnos,
    produto_id,
    tipo_produto,
    user.empresa_id,
  ]);

  const classes = useStyles();

  const handleChange = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ): void => {
    setDrawerValue(newValue);
  };

  const toggleDrawer = (open: boolean) => () => {
    setIsOpen(open);
    cleanData();
    handleSetHasProductUpdated(false);
  };

  return (
    <>
      <MenuOptionButton type="button" onClick={toggleDrawer(true)}>
        Clonar Produto
      </MenuOptionButton>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Novo Produto</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={drawerValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product_tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} style={{ fontSize: '14px' }} />
                    {tipo_produto !== 2 && (
                      <Tab label="Complementos" {...a11yProps(1)} style={{ fontSize: '14px' }} />
                    )}
                    {tipo_produto !== 2 && (
                      <Tab label="Disponibilidade" {...a11yProps(2)} style={{ fontSize: '14px' }} />
                    )}
                  </Tabs>
                </AppBar>

                <TabPanel value={drawerValue} index={0}>
                  <Detalhes
                    id_grupo={grupo_id}
                    descricao_grupo={grupo_descricao}
                    tipo_produto={tipo_produto}
                  />
                </TabPanel>

                {tipo_produto !== 2 && (
                  <div>
                    <TabPanel value={drawerValue} index={1}>
                      <Complementos grupo_produto_id={grupo_produto_id} />
                    </TabPanel>

                    <TabPanel value={drawerValue} index={2}>
                      <Disponibilidade />
                    </TabPanel>
                  </div>
                )}
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default CloneProdutoSimples;
